import React, { useEffect, useState } from 'react'
import SubscriptionPlan from './SubscriptionPlan';
import SubscriptionUsage from './SubscriptionUsage';
import { Button } from 'flowbite-react';
import { useSubscriptionStore, subscription } from '../../../state/useSubscriptionStore';
import { SidebarDrawer } from '../../common';
import CancelSubscriptionPrompt from './cancelSubscriptionPrompt';
import { createSubscription, getSubscriptionHistory, getActiveSubscription } from '../../../backend-services/subscription';
import SubscriptionHistory from './SubscriptionHistory';
import PageLoader from '../../common/PageLoader';
import { useUserStore } from '../../../state';

interface Props {
  submenuTab: string;
  onBack: () => void;
  bankSubmenuTab: string;
}

const Subscription = (props: Props) => {

  const [showPrompt, setShowPrompt] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState(false)

  const {subscription, getSubscription} = useSubscriptionStore( ( state ) =>  ( {
    subscription: state.subscription,
    getSubscription: state.getSubscription,
  } ))

  const [subscriptionState, setSubscriptionState] = useState<subscription | null>(null)
  const[history, setHistory] = useState([])

  const getHistoryData = async () => {
    setIsLoading(true)
   try {
    const data = await getSubscriptionHistory()
    setHistory(data)
    return data
   } catch (error:any) {
      setIsLoading(true)
      throw new Error(error?.message)
   }
   finally{
    setIsLoading(false)
   }}

   const { user, fetchUser } = useUserStore( (state) => ({
    user: state.user,
    fetchUser: state.fetchUserProfile
 }))

 useEffect(() => {
   getSubscription()
   console.log(subscription)
   setSubscriptionState(subscription)
 }, [subscription, subscriptionState])


  useEffect(() => {
   getHistoryData()
  },[])

  const handleSubscriptionDeleteSuccess = () => {
     setShowPrompt(false)
  } 

  return (
    <>
    {isLoading ? <PageLoader/> :
  <div>
       <div className='flex flex-col justify-center items-center md:items-stretch md:justify-start'>
            <div className="bg-[#FFFFFF] max-w-[350px] sm:max-w-full min-h-screen mx-[-70px] sm:mx-0 md:mx-0 rounded-[7px] mt-[32px]">
            <div className="flex flex-col gap-[7px]">
            <div className='flex flex-row lg:items-center justify-between pl-[16px] pr-[16px] sm:pl-[24px] lg:pl-[40px] 1280:pl-[20px] xl:pl-[64px]  sm:pr-[24px] lg:pr-[64px] pt-[16px] md:pt-[54px]'>
              <span className='flex flex-col gap-[7px]'>
              <h3 className="text-[16px] md:text-[1.25rem] text-[#00000] leading-6  font-semibold">Subscription Plan</h3>
              <p className="text-[12px] md:text-[1rem] md:leading-5  font-normal">Manage your Subscription <br className='block md:hidden'/> Plans</p>
              </span>
              <button onClick={() => setShowPrompt(true)} className='border border-[#FB0303] rounded-[4px] py-[11px] px-[13px] lg:w-[215px] md:py-[16px] md:px-[34px] text-[#FB0303] text-[16px] whitespace-nowrap' style={{fontWeight: 600}}>
                Cancel Plan
              </button>
              </div>
              <hr className='mt-[13px] mb-[24px] md:mb-[29px]'/>
            <div className='flex flex-col gap-[29.5px] lg:flex-row w-full px-[16px] sm:px-[24px] lg:px-0 lg:pl-[40px] xl:pl-[61px] 2xl:pl-[61px] lg:pr-[128px]'>
                 <SubscriptionPlan subscriptionState={subscriptionState}/>
                 <SubscriptionUsage subscriptionState={subscriptionState}/>
            </div>
            </div>   
              <div className='pl-[16px] pr-[16px] sm:pl-[24px] lg:pl-[40px] 1280:pl-[20px] xl:pl-[64px]  sm:pr-[24px] lg:pr-[64px] pt-[16px] md:pt-[54px]'>
              <h3 className="text-[16px] md:text-[1.25rem] text-[#00000] leading-6  font-semibold">Subscription History</h3>
               <SubscriptionHistory isLoading={isLoading} history={history}/>
               </div>
            </div>
        </div>

        <SidebarDrawer 
            title={'Cancel Subscription'} 
            show={showPrompt} 
            position={'left'} 
            onClose={() => setShowPrompt(false)}>
            <CancelSubscriptionPrompt 
            showPrompt={showPrompt} 
            show={() => setShowPrompt(false)}
            onClose={() => setShowPrompt(false)}
            onDeleteSuccess={handleSubscriptionDeleteSuccess}
               />
    </SidebarDrawer>
    </div>
    
  
  }
    
    </>
    
  )
}

export default Subscription